var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('PlayerBarCloseButton'),_c('PlayerBarOnAirInfo'),_c('PlayerControls'),_c('VolumeSlider',{attrs:{"volume":_vm.volume}}),_c('ChangeStreamTypeButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }